import { Separator } from '@radix-ui/react-separator'
import { ChevronRight } from 'lucide-react'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Button } from '@/components/button'
import { ScrollArea, ScrollBar } from '@/components/scroll-area'
import { useSidebar } from '@/contexts'

import { menuOptions } from '../utils/menu-options'
import { MenuCollapsible } from './menu-collapsible'
import { MenuOption } from './menu-option'

export function BackOfficeSideBar({
  className,
}: React.HTMLAttributes<HTMLDivElement>) {
  const { sidebarOpen, toggleSidebar } = useSidebar()

  return (
    <div
      className={twMerge(
        'over bg-bios-neutral-50 relative py-4 transition-all',
        className,
        sidebarOpen ? 'w-64' : 'w-20',
      )}
    >
      <Button
        data-testid="toggle-sidebar-button"
        onClick={toggleSidebar}
        className="absolute right-0 z-10 flex h-8! w-8! translate-x-1/2 items-center justify-center rounded-full p-0"
      >
        <ChevronRight
          className={twMerge(
            'transition-transform duration-500 ease-linear',
            sidebarOpen && 'rotate-180',
          )}
        />
      </Button>

      <ScrollArea className="lg:h-[calc(100vh-9rem)]">
        {menuOptions.map(({ label, path, icon, type, items, isDisabled }) => (
          <React.Fragment key={label}>
            {type === 'group' ? (
              <MenuCollapsible
                icon={icon}
                label={label}
                items={items || []}
                sidebarOpen={sidebarOpen}
              />
            ) : (
              <MenuOption
                path={path}
                icon={icon}
                label={label}
                sidebarOpen={sidebarOpen}
                isDisabled={isDisabled}
              />
            )}
            <Separator
              orientation="horizontal"
              className="bg-monochromatic-500/20 h-px last:hidden"
            />
          </React.Fragment>
        ))}

        <ScrollBar orientation="vertical" />
      </ScrollArea>
    </div>
  )
}
